import { ripple } from './directives/ripple.js';
import { show } from './directives/show.js';
import { on } from './directives/on.js';
import { bind } from './directives/bind.js';
import { text } from './directives/text.js';
import { hide } from './directives/hide.js';
import { html } from './directives/html.js';
import { style } from './directives/style.js';

const listOfDirectives = { text, bind, on, show, ripple, hide, html, style };

const getDirective = name => directives[name];
const getDirectiveSelector = name => getDirective(name)?.selector;
const runDirective = (name, target, ...args) => getDirective(name)?.run(target, ...args);

export { listOfDirectives };
